/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Passkey_FailedInputs */

const en_signin_passkey_failed = /** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That passkey did not work`)
};

/** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */
const ar_signin_passkey_failed = en_signin_passkey_failed;

/** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */
const he_signin_passkey_failed = en_signin_passkey_failed;

/** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */
const ur_signin_passkey_failed = en_signin_passkey_failed;

/** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */
const es_signin_passkey_failed = en_signin_passkey_failed;

/** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */
const fr_signin_passkey_failed = en_signin_passkey_failed;

/** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */
const de_signin_passkey_failed = en_signin_passkey_failed;

/** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */
const pt_signin_passkey_failed = en_signin_passkey_failed;

/** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */
const hi_signin_passkey_failed = en_signin_passkey_failed;

/** @type {(inputs: Signin_Passkey_FailedInputs) => LocalizedString} */
const bn_signin_passkey_failed = en_signin_passkey_failed;

/**
* | output |
* | --- |
* | "That passkey did not work" |
*
* @param {Signin_Passkey_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_passkey_failed = /** @type {((inputs?: Signin_Passkey_FailedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Passkey_FailedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_passkey_failed(inputs)
	if (locale === "he") return he_signin_passkey_failed(inputs)
	if (locale === "ur") return ur_signin_passkey_failed(inputs)
	if (locale === "es") return es_signin_passkey_failed(inputs)
	if (locale === "fr") return fr_signin_passkey_failed(inputs)
	if (locale === "de") return de_signin_passkey_failed(inputs)
	if (locale === "pt") return pt_signin_passkey_failed(inputs)
	if (locale === "hi") return hi_signin_passkey_failed(inputs)
	if (locale === "bn") return bn_signin_passkey_failed(inputs)
	return /** @type {LocalizedString} */ ("That passkey did not work")
});